
export async function GetUserModel() {
  let token = window.localStorage.getItem('token');
  if (token) {
    try {
      let res = await fetch('https://stg-api.cortishare.com/api/app/WebXR/GetUserObjects', {
        method: 'GET', // or 'PUT'
        headers: {
          "accept": "*/*",
          "X-XSRF-TOKEN": "CfDJ8JJvQWwoN1dFtIXx8cOdPtEYxAJF-164ZNgU7IQpYiPDtSKTR_OJq8rIkZzg2PHA_nOnEaNds6i22F9-nUiimkoEHhObZihUWQtlVmZx0_Ccz_26vZeZdQCUXQRPKqk6cGHPfMJF8Y_IItueiqwNBr0",
          "Authorization": "Bearer " + token,
        },
      });
      return await res.json();
    } catch (error) {
      console.log(error);
    }
  }
  else {
     return null;
  }
}